import { ChevronDown, ChevronUp, Tag } from 'lucide-react'
import { useState } from 'react'
import { useProblem } from './problem-context'

export function TopicsSection() {
  const { data, testCasesLoading } = useProblem()
  const [expanded, setExpanded] = useState(false)

  if (testCasesLoading) return null

  const topics = data?.topics ?? []

  return (
    <section className="border-t border-gray-200 pt-6 dark:border-gray-700">
      <button
        type="button"
        aria-expanded={expanded}
        onClick={() => setExpanded((v) => !v)}
        className="flex w-full items-center justify-between text-left text-gray-900 dark:text-gray-100"
      >
        <span className="flex items-center gap-2 font-semibold">
          <Tag className="h-4 w-4" aria-hidden="true" />
          Topics
        </span>
        {expanded ? (
          <ChevronUp className="h-4 w-4" aria-hidden="true" />
        ) : (
          <ChevronDown className="h-4 w-4" aria-hidden="true" />
        )}
      </button>
      {expanded && (
        <div data-testid="topics-body" className="mt-3 flex flex-wrap gap-2">
          {topics.map((topic) => (
            <a
              key={topic.slug}
              href={`/problems/topics/${topic.slug}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center rounded-full border border-transparent bg-slate-100 px-3 py-1 text-xs text-slate-600 transition-colors hover:bg-blue-100 hover:text-blue-600 dark:bg-slate-500/20 dark:text-slate-400 dark:hover:bg-blue-900/30 dark:hover:text-blue-400"
            >
              {topic.name}
            </a>
          ))}
        </div>
      )}
    </section>
  )
}
